import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { UpdateFreshdeskProfile } from '../../../apiclients/streamsapi_bridge';

function DeleteProfileUser(props) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false)

    async function deleteUser(e) {
        e.preventDefault();
        console.log(props.agentid);
        const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
        setIsloading(true);
        let update = {
            reqid: 127,
            siteid: siteid,
            remove_users: [props.agentid],
            profileid: props.profileInfo.profileid,
        }


        console.log("reques for delete user in DeleteProfileUser   :::: " + JSON.stringify(update));
        let deleteFilter = await UpdateFreshdeskProfile(update);
        setTimeout(() => {
            setIsloading(false);
        }, 1000);
        let deleteMsg = await deleteFilter.json();
        console.log("Response... ");
        console.log(deleteMsg);
        if (deleteMsg.status == "Failed") {
            localStorage.setItem(
                "user_create_f",
                "Something went wrong, Please try again after sometime"
            );
            props.onClose();
            window.location.href = "/apidetails";
        } else if (deleteMsg.status == "success") {
            props.setSuccessMessage(deleteMsg.message);
            navigate("/apidetails", {
                state: { tab: "tab2", profileInfo: props.profileInfoObj },
            });


            window.location.reload();
        }
    }

    return (
        <>
            {isloading && (
                <>
                    <div className="loadingclass">
                        <MDBBtn disabled>
                            <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                            Loading...
                        </MDBBtn>
                    </div>
                </>
            )}
            <div>
                <span className="phrecording">{t("RemoveUsertxt")}</span>
            </div>
            <MDBModalFooter>
                <MDBBtn color="secondary" onClick={props.onClose}>
                    {t("cancel")}
                </MDBBtn>
                <MDBBtn onClick={(e) => deleteUser(e)}>{t("remove")}</MDBBtn>
            </MDBModalFooter>
        </>
    )
}

export default DeleteProfileUser
